<template>
  <div class="chat-iframe">
    <div v-if="isLoading || isError" class="iframe-overlay">
      <icon-loading v-if="isLoading" />
      <icon-error v-else-if="isError" />
    </div>
    <iframe ref="iframeRef" :src="src" width="100%" height="100%" />
  </div>
</template>

<script setup lang="ts">
import IconError from '@/components/icons/IconError.vue';
import IconLoading from '@/components/icons/IconLoading.vue';
import { useIframe } from '@/composables/shared/useIframe';
import { useToastStore } from '@/stores/toast';
import { IframeMessage } from '@/types/iframe';

const props = withDefaults(
  defineProps<{
    code: string;
  }>(),
  {
    code: '',
  }
);

const emit = defineEmits<{ updated: [] }>();

const { t } = useI18n();

const toastStore = useToastStore();

const event_map = {
  CALL_EDIT_SAVED: (data: IframeMessage) => {
    if (data.success && data.data) {
      toastStore.info(t('alert_save_completed'));
      emit('updated');
    } else if (data.error) {
      toastStore.error(data.error);
    }
  },
};

const src = computed<string>(() => {
  const url = window.location.origin;
  return `${url}/admin/external/call-edit/${props.code}?authToken=${localStorage.getItem('authToken')}`;
});

const handleIframeMessage = (data: IframeMessage) => {
  const event = event_map[data.type];
  event?.(data);
};

const { iframeRef, isLoading, isError } = useIframe('iframeRef', { onMessage: handleIframeMessage });
</script>

<style scoped lang="scss">
.chat-iframe {
  position: relative;
  height: 700px;
  max-height: 700px;
  overflow-y: auto;
  overflow-x: hidden;

  .iframe-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #ffffff;
    width: 100%;
    height: 100%;
  }
}
</style>
